import { useState, useEffect } from "react";

function ScrollTop() {
  const [nearTop, setNearTop] = useState(false);

  function scrollToTop() {
    document.body.scrollTop = 145;
    document.documentElement.scrollTop = 145;
  }

  useEffect(() => {
    window.onscroll = function () {
      if (
        document.body.scrollTop > 250 ||
        document.documentElement.scrollTop > 250
      ) {
        setNearTop(true);
      } else {
        setNearTop(false);
      }
    };
  }, []);

  return (
    <div
      className={`NSC-scroll-top ${nearTop ? "NSC-scroll-top-show" : ""}`}
      onClick={scrollToTop}
    >
      <img
        className="arrow-up-icon"
        src="./arrow-up.png"
        alt="scroll up icon"
      />
    </div>
  );
}

export default ScrollTop;
